import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormWrapperModule } from '@shared/form-wrapper/form-wrapper.module';
import { TranslateModule } from '@ngx-translate/core';
import { NgxMaskModule } from 'ngx-mask';
import { DirectivesModule } from '@shared/directives/directives.module';
import { NgxIntlTelInputModule } from 'ngx-intl-tel-input';

import { ContainerFreightStorageManagerEditComponent, ContainerFreightStorageManagerViewComponent } from './components';
import { PipesSharedModule } from '@shared/pipes-shared/pipes-shared.module';
import { RouterModule } from '@angular/router';
import { InputPhoneModule } from '@shared/input-phone/input-phone.module';

@NgModule({
  declarations: [ContainerFreightStorageManagerEditComponent, ContainerFreightStorageManagerViewComponent],
  imports: [
    CommonModule,
    FormWrapperModule,
    TranslateModule,
    NgxMaskModule,
    DirectivesModule,
    NgxIntlTelInputModule,
    PipesSharedModule,
    RouterModule,
    InputPhoneModule,
  ],
  exports: [ContainerFreightStorageManagerEditComponent, ContainerFreightStorageManagerViewComponent],
})
export class ContainerFreightStoragesManagersModule {}
